import { jobIsAvailableRouteGuard } from '@apps/customer/routeGuards';
import type { RouteRecordRaw } from 'vue-router';

export const CUSTOMER_CART_PAGE = 'customer-cart';
export const CUSTOMER_CART_ORDER_SERVICE_PAGE = 'customer-cart-order_services';

const routes: RouteRecordRaw[] = [
  {
    path: ':jobId/cart',
    children: [
      {
        name: CUSTOMER_CART_PAGE,
        path: '',
        component: () => import('./pages/cart/CartPage.vue'),
        beforeEnter: [jobIsAvailableRouteGuard],
      },
      {
        name: CUSTOMER_CART_ORDER_SERVICE_PAGE,
        path: 'services',
        component: () => import('./pages/cartOrderServices/CartOrderServicesPage.vue'),
        beforeEnter: [jobIsAvailableRouteGuard],
      },
    ],
  },
];
export default routes;
